module.exports = __webpack_public_path__ + "static/media/malt-l.8d545088.mp3";